import gql from 'graphql-tag';

export const ORGANIZATION_UPDATE_MUTATION = gql`
  mutation Organization($organization: OrganizationUpdateInput) {
    updateOrganization(organization: $organization) {
      authoritativeSignature
      betaTester
      busySignInQuestion
      createdOn
      defaultBreakDuration
      defaultEndTime
      defaultStartTime
      deletedOn
      demo
      disclaimer
      id
      imageId
      inRecoveryMode
      gustoCompanyId
      lockOnSelfSignature
      minimumAppVersion
      organizationSettings
      organizationInfo {
        id
        organizationId
        longitude
        latitude
        address1
        address2
        city
        county
        state
        postalCode
        country
        phone
        trade
        currencyCode
        employeeMin
        employeeMax
        createdOn
        submittedOn
        updatedOn
        deletedOn
      }
      organizationPayPeriod {
        id
        organizationId
        payPeriodType
        startDate
        dayOne
        dayTwo
        createdOn
        submittedOn
        updatedOn
        deletedOn
      }
      organizationOvertimePeriods {
        id
        organizationId
        startTime
        lengthInDays
        weeklyOvertime
        dailyOvertime
        dailyDoubletime
        seventhDayOvertime
        seventhDayDoubletime
        saturdayMultiplier
        sundayMultiplier
        createdOn
        submittedOn
        updatedOn
        deletedOn
      }
      organizationName
      overtimeFlag
      ownedBy
      requireCostCode
      requireProject
      revokedOn
      safetySignature
      safetySignatureMessage
      signatureDate
      stripeAccountCreatedOn
      stripeAccountStatus
      stripeAccountType
      stripeCustomerId
      submittedOn
      breakPolicy
      breakPolicyCalifornia
      breakPolicyMessage
      bulletin
      performanceScores
      timeAccuracy
      timeAccuracyMessage
      timeRounding
      timeRoundingInterval
      timeRoundingType
      totalTimeFlag
      trackBudgets
      trackBudgetCost
      trackBudgetEquipmentCosts
      trackBudgetEquipmentHours
      trackBudgetProgress
      trackBudgetProgressValue
      trackCostCode
      trackEquipment
      trackPaidBreak
      trackProject
      updatedOn
      useProjectCostCodeScoping
      webGps
      hideUnassignedSubprojects
      timeOffRequests
    }
  }
`;
